export const PAYOUTS = [
3600000,
2160000,
1360000,
960000,
800000,
720000,
670000,
620000,
580000,
540000,
500000,
460000,
420000,
380000,
360000,
340000,
320000,
300000,
280000,
260000,
240000,
224000,
208000,
192000,
176000,
160000,
154000,
148000,
142000,
136000,
130000,
124000,
118000,
113000,
108000,
103000,
98000,
94000,
90000,
86000,
82000,
78000,
74000,
70000,
66000,
62000,
58000,
54800,
52000,
50400,
50400,
50400,
10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000, 10000,
];
